import { useEffect } from 'react';
import { useLazyGetUserCurrentPlanQuery } from '../../../modules/settings/slice/createSettingApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, setCredentials } from '../../../modules/authentication/slice/authSlice';
import { setIsLoadingCurrentPlan, setIsSuccessUpgradePlan, setPlansModalOpen } from '../../../modules/settings/slice/settingsSlice';
import { message } from 'antd';

export const useGetUserCurrentPlan = () => {
    const dispatch = useDispatch()
    const user = useSelector(selectCurrentUser)
    const [getCurrentPlan, { data, isError, isSuccess }] = useLazyGetUserCurrentPlanQuery()

    const getUserPlan = async () => {
        await getCurrentPlan()
    }

    useEffect(() => {
        if (isSuccess) {
            dispatch(setCredentials({ user: { ...user, plan: data?.data } }))
            dispatch(setPlansModalOpen(false))
            dispatch(setIsLoadingCurrentPlan(false))
            dispatch(setIsSuccessUpgradePlan(false))
        } else if (isError) {
            dispatch(setPlansModalOpen(false))
            dispatch(setIsLoadingCurrentPlan(false))
            dispatch(setIsSuccessUpgradePlan(false))
            message.error('Reload the page to get your current plan', 5)
        }
        // eslint-disable-next-line
    }, [data, isError, isSuccess, dispatch])

    return { getUserPlan }
};
